
<template>
  <div>
    <v-card flat>
      <v-card-title class="d-flex align-center justify-end" v-if="!without_actions">
        <f-btn edit v-if="user_allowed && !edit"  small class="ml-2" @click="startEditing"></f-btn>
        <f-btn cancel v-if="user_allowed && edit"  small class="ml-2" @click="cancelEditing"></f-btn>
        <f-btn save v-if="user_allowed && edit" :disabled="model_object.modality_ids.length == 0" small class="ml-2" @click="saveChanges"></f-btn>
      </v-card-title>
      <v-card-text :class="[['pa-2'],[edit && !without_actions ? 'elevation-4':'']]">
        <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>
        <SelectModality multiple :object_with_model="model_object" model="modality_ids" :index_by_current_user="false"/>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'EditSolutions',
  components: {
    SelectModality:()=> import("@/components/shared/SelectModality.vue")
  },
  props:{
    model_modality_ids:{
      type: Array,
      default: () => []
    },
    model:{
      type: Object,
      default: () => { return { text:"cliente", API: "Client", METHOD:"basicUpdate"} }
    },
    without_actions:{
      type: Boolean,
      default: false
    },
    readonly:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      aux_selected_ids:  [],
      edit: false,
      saving: false,
      model_object: {
        modality_ids: [],
      }
    }
  },
  computed: {
    user_allowed() {
      return this.isManager() || this.isDirector() || this.isFinancial() || this.isSalesExecutive() || this.isAnalyst() || this.isCreditAnalyst() || this.isLogistics()
    },
  },
  methods: {
    getData(){
      if(this.without_actions){
        this.startEditing()
      }
    },
    startEditing(){
      this.edit = true
      this.$emit('edit')
    },
    cancelEditing(){
      this.edit = false
      this.$emit('cancel')
      this.model_object.modality_ids = [...this.aux_selected_ids ]
    },
    prepareUpdate(){
      return{
        id: this.$route.params.id,
        modality_ids: this.model_object.modality_ids,
      }
    },
    saveChanges(){
      this.swallConfirmation({
          title: `Deseja atualizar ${this.model.text}?`,
          icon: 'question',
        }).then( confirmed =>{
          if ( confirmed ) {
            this.saving = true
            let data = this.prepareUpdate()

            Api[this.model.API][this.model.METHOD](data).then(()=>{
              this.successUpdated()
              this.edit = false
              this.$emit('update')
            })
            .catch((er)=>{
              this.addNotification({type: 'error', msg: er})
              this.cancelEditing()
            })
            .finally(()=>{
              this.$emit('cancel')
              this.saving = false
            })
          }
          
        })
    },

  },
  mounted(){
    this.getData()
    let ids = JSON.parse(JSON.stringify(this.model_modality_ids))
    this.aux_selected_ids = ids
    this.model_object.modality_ids = ids
  },
  watch:{
    // modality_ids(){
    //   this.setSelectedIds()
    // }
  },
}
</script>